import { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import Link from '@/features/ref/components/Link'
import CloseIcon from '@mui/icons-material/Close'
import { Swiper, SwiperSlide } from 'swiper/react'
import { VideoReel } from './VideoReel'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import { Box, IconButton, Stack, styled } from '@mui/material'
import { IReel } from '../types'

const StyledLink = styled(Link)(({ theme }) => ({
  display: 'block',
  width: '7.6rem',
  [theme.breakpoints.up('md')]: {
    width: '12rem',
  },
}))
export const PopupWatcherReels = ({
  reels,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  open,
  setOpen,
  currentReel,
}: {
  reels: (IReel | undefined)[]
  hasNextPage: any
  isFetchingNextPage: any
  fetchNextPage: any
  open: boolean
  setOpen: (open: boolean) => void
  currentReel: number
}) => {
  const swiperRef = useRef(null)
  const [currentIndex, setCurrentIndex] = useState(currentReel)
  useEffect(() => {
    if (open) {
      // document.body.style.overflow = 'hidden'
      // @ts-ignore
      swiperRef.current?.swiper.slideTo(currentReel)
      setCurrentIndex(currentReel)
    } else {
      // document.body.style.overflow = 'auto'
    }
  }, [open, currentReel])
  const handleVideoEnded = () => {
    // @ts-ignore
    const swiper = swiperRef.current?.swiper
    if (!swiper) return

    const nextIndex = currentIndex + 1
    const totalSlides = swiper.slides.length

    if (nextIndex < totalSlides) {
      swiper.slideTo(nextIndex)
      setCurrentIndex(nextIndex)
    }
  }
  return (
    <motion.div
      initial={{ opacity: 0, display: 'none' }}
      animate={open ? { opacity: 1, display: 'flex' } : {}}
      exit={{ opacity: 0, display: 'none' }}
      transition={{ duration: 0.3 }}
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 999,
        display: 'flex',
        height: '100vh',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'black',
      }}
    >
      <Box
        position="absolute"
        left={4}
        right={4}
        top={4}
        sx={{
          display: 'flex',
          cursor: 'pointer',
          justifyContent: 'space-between',
          borderRadius: '9999px',
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, lg: 1 }}>
          <StyledLink href="/">
            <Box
              component="img"
              src="/assets/images/logo.png"
              alt=""
              sx={{ display: 'block', width: '100%' }}
            />
          </StyledLink>
        </Stack>
        <IconButton
          onClick={() => setOpen(false)}
          sx={{
            bgcolor: 'rgba(255,255,255,0.8)',
            height: 'fit-content',
            color: '#252422',
            p: 1,
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.9)',
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Stack spacing={0}>
        <Swiper
          spaceBetween={16}
          ref={swiperRef}
          slidesPerView={'auto'}
          pagination={{
            clickable: true,
          }}
          slideToClickedSlide={true}
          centeredSlides={true}
          onSlideChange={(swiper) => {
            setCurrentIndex(swiper.activeIndex)
            const currentIndex = swiper.activeIndex
            const totalSlides = swiper.slides.length
            // Nếu gần cuối, fetch thêm dữ liệu
            if (currentIndex >= totalSlides - 6 && hasNextPage && !isFetchingNextPage) {
              fetchNextPage()
            }
          }}
        >
          {reels?.map((reel, index) => (
            <SwiperSlide
              key={index}
              className={`!w-[40vh] md:!w-[40vh] ${index === currentIndex ? 'opacity-100' : 'opacity-50'}`}
            >
              <VideoReel
                index={index}
                play={index === currentIndex && open}
                reel={reel}
                onEnded={handleVideoEnded}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Stack>

      <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} gap={2} mt={2}>
        <IconButton
          sx={{
            display: 'flex',
            width: 40,
            aspectRatio: '1/1',
            bgcolor: 'rgba(255,255,255,0.4)',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '999px',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.6)' },
          }}
          onClick={() => {
            // @ts-ignore
            swiperRef.current?.swiper.slidePrev()
          }}
        >
          <ArrowBackIosNewIcon sx={{ color: 'white', fontSize: '18px' }} />
        </IconButton>

        <IconButton
          sx={{
            display: 'flex',
            width: 40,
            aspectRatio: '1/1',
            bgcolor: 'rgba(255,255,255,0.4)',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '999px',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.6)' },
          }}
          onClick={() => {
            // @ts-ignore
            swiperRef.current?.swiper.slideNext()
          }}
        >
          <ArrowBackIosNewIcon sx={{ transform: 'rotate(180deg)', color: 'white', fontSize: '18px' }} />
        </IconButton>
      </Stack>
    </motion.div>
  )
}
